var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Icon } from './Icon';
export var EmptyHeartIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { role: "button" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.71573 4.7284C1.42809 7.03294 1.42809 10.7693 3.71573 13.0739L11.2903 20.7044L11.2955 20.7096C11.6875 21.0987 12.3206 21.0963 12.7097 20.7044L20.2843 13.0739C22.5719 10.7693 22.5719 7.03294 20.2843 4.7284C17.9966 2.42387 14.2876 2.42387 12 4.7284C9.71236 2.42387 6.00337 2.42387 3.71573 4.7284ZM19.5827 12.3446L12.3549 19.6259L12.3523 19.6285C12.1563 19.8231 11.8397 19.8219 11.6451 19.6259L4.41727 12.3446C2.52758 10.441 2.52758 7.36129 4.41727 5.45763C6.31569 3.54519 9.40003 3.54519 11.2985 5.45763L12 6.16436L12.7015 5.45763C14.6 3.54519 17.6843 3.54519 19.5827 5.45763C21.4724 7.36129 21.4724 10.441 19.5827 12.3446Z", fill: "#002333" }))); };
//# sourceMappingURL=EmptyHeartIcon.js.map